// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"28":"bcf31c40fcddabbe","34":"d9fdd1cdacedac39","281":"fa82b3d5103bb31f","616":"fbefe0aad4f53d97","665":"3d8030a51abb1a42"}[chunkId] + ".js";
};